export default __webpack_public_path__ + "static/infantCurious-db5eb65f74d8754e20f4b6a28624ae22.svg";